import type { FC } from 'react';

import { NavigationDropdownMenu } from '../navigation-dropdown-menu/navigation-dropdown-menu';
import { NavigationTrigger } from '../navigation-trigger/navigation-trigger';
import type { MenuItem } from '../navigation.constants';

interface NavigationItemProps {
  item: MenuItem;
}

export const NavigationItem: FC<NavigationItemProps> = ({ item }) => {
  if (item.submenu) {
    return (
      <NavigationDropdownMenu
        name={item.text}
        rootPath={item.to}
        items={item.submenu}
      />
    );
  }

  return <NavigationTrigger name={item.text} to={item.to} />;
};
